import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkmark-icon",
  "use": "checkmark-icon-usage",
  "viewBox": "0 0 29 29",
  "content": "<symbol viewBox=\"0 0 29 29\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"checkmark-icon\">\n\t<path d=\"M12.0844 18.3328L23.1914 7.22461L24.9012 8.93319L12.0844 21.75L4.39453 14.0602L6.10311 12.3516L12.0844 18.3328Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol